<div class="form-item">
    <label class="form-label" for="{{label + side}}">{{label}}</label>
    <div class="form-input" *ngIf="loaded">
      <edit-data [inputId]="label + side"  [canEdit]="true" [value]="text" dataType="number" (valueChanged)="updateRecord($event)"></edit-data>
    </div>
    <div>
      <app-additional-record-image *ngIf="image=='' " (onPhotoUpload)="loadPhoto()" matTooltip="Upload Photo"  [recordId]="recordId"
      [id]="id" [side]="side" [inspectionId]="inspectionId" [type]="3"></app-additional-record-image>
      <!-- <img *ngIf="image!='' " (click)="viewPhoto()" [src]="getImage(image)" class="component-photo"  /> -->
      <i  *ngIf="image != ''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;margin-left: 8px;    cursor: pointer;"  (click)="viewPhoto()" >
        add_a_photo
      </i>
    </div>
  </div>
  